const PAGE_RAIL_WIDTH = '88px';

const CHANGES_PANEL_WIDTH = '280px';

export const getPagedPreviewStyles = hasMarks => ({
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    md: hasMarks
      ? `${PAGE_RAIL_WIDTH} minmax(0, 1fr) ${CHANGES_PANEL_WIDTH}`
      : `${PAGE_RAIL_WIDTH} minmax(0, 1fr)`,
  },
  alignItems: 'start',
  gap: '16px',
  minWidth: 0,
});

export const previewPanesStyles = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' },
  gap: '48px',
  minWidth: 0,
  paddingLeft: '40px',
};
